'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ajax = require('linksoft/initializers/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _dataTable = require('linksoft/initializers/data-table');

var _dataTable2 = _interopRequireDefault(_dataTable);

var _select = require('linksoft/initializers/select2');

var _select2 = _interopRequireDefault(_select);

var _tooltip = require('linksoft/initializers/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _notify = require('linksoft/initializers/notify');

var _notify2 = _interopRequireDefault(_notify);

var _confirm = require('linksoft/initializers/confirm');

var _confirm2 = _interopRequireDefault(_confirm);

var _switcher = require('linksoft/initializers/switcher');

var _switcher2 = _interopRequireDefault(_switcher);

var _showRelated = require('linksoft/initializers/show-related');

var _showRelated2 = _interopRequireDefault(_showRelated);

var _lazyImage = require('linksoft/initializers/lazy-image');

var _lazyImage2 = _interopRequireDefault(_lazyImage);

var _dispatchAction = require('linksoft/initializers/dispatch-action');

var _dispatchAction2 = _interopRequireDefault(_dispatchAction);

var _trigger = require('linksoft/initializers/trigger');

var _trigger2 = _interopRequireDefault(_trigger);

var _dropzone = require('linksoft/initializers/dropzone');

var _dropzone2 = _interopRequireDefault(_dropzone);

var _moment = require('./moment');

var _moment2 = _interopRequireDefault(_moment);

var _datepicker = require('./datepicker');

var _datepicker2 = _interopRequireDefault(_datepicker);

var _tabs = require('./tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _productLists = require('./productLists');

var _productLists2 = _interopRequireDefault(_productLists);

var _downloadIcons = require('./downloadIcons');

var _downloadIcons2 = _interopRequireDefault(_downloadIcons);

var _gallery = require('./gallery');

var _gallery2 = _interopRequireDefault(_gallery);

var _clearModal = require('./clearModal');

var _clearModal2 = _interopRequireDefault(_clearModal);

var _editCell = require('./edit-cell');

var _editCell2 = _interopRequireDefault(_editCell);

var _initializer = require('./complaints/initializer');

var _initializer2 = _interopRequireDefault(_initializer);

var _nestable = require('./nestable');

var _nestable2 = _interopRequireDefault(_nestable);

var _menuItemCopy = require('./menuItemCopy');

var _menuItemCopy2 = _interopRequireDefault(_menuItemCopy);

var _productPriority = require('./productPriority');

var _productPriority2 = _interopRequireDefault(_productPriority);

var _watchdogAuthor = require('./watchdogAuthor');

var _watchdogAuthor2 = _interopRequireDefault(_watchdogAuthor);

var _appliedDiscounts = require('./appliedDiscounts');

var _appliedDiscounts2 = _interopRequireDefault(_appliedDiscounts);

var _userComplaints = require('./userComplaints');

var _userComplaints2 = _interopRequireDefault(_userComplaints);

var _dataCopy = require('./data-copy');

var _dataCopy2 = _interopRequireDefault(_dataCopy);

var _newsletters = require('./newsletters');

var _newsletters2 = _interopRequireDefault(_newsletters);

var _productPriceCheck = require('./productPriceCheck');

var _productPriceCheck2 = _interopRequireDefault(_productPriceCheck);

var _clipboard = require('./clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

var _cmsPageSections = require('./cmsPageSections');

var _cmsPageSections2 = _interopRequireDefault(_cmsPageSections);

var _cmsPageSectionFiles = require('./cmsPageSectionFiles');

var _cmsPageSectionFiles2 = _interopRequireDefault(_cmsPageSectionFiles);

var _contestResponses = require('./contestResponses');

var _contestResponses2 = _interopRequireDefault(_contestResponses);

var _select2templates = require('./select2templates');

var _select2templates2 = _interopRequireDefault(_select2templates);

var _closeModal = require('./closeModal');

var _closeModal2 = _interopRequireDefault(_closeModal);

var _productWishList = require('./initializers/productWishList');

var _productWishList2 = _interopRequireDefault(_productWishList);

var _dropzoneMaxFilesize = require('./initializers/dropzoneMaxFilesize');

var _dropzoneMaxFilesize2 = _interopRequireDefault(_dropzoneMaxFilesize);

var _fileManagerBreadcrumbs = require('./fileManagerBreadcrumbs');

var _fileManagerBreadcrumbs2 = _interopRequireDefault(_fileManagerBreadcrumbs);

var _updateImageId = require('./updateImageId');

var _updateImageId2 = _interopRequireDefault(_updateImageId);

var _dynamicLoadContent = require('./dynamicLoadContent');

var _dynamicLoadContent2 = _interopRequireDefault(_dynamicLoadContent);

var _fileManagerFolder = require('./fileManagerFolder');

var _fileManagerFolder2 = _interopRequireDefault(_fileManagerFolder);

var _removeTooltipManual = require('./removeTooltipManual');

var _removeTooltipManual2 = _interopRequireDefault(_removeTooltipManual);

var _onHoverDynamicShowThumbnail = require('./onHoverDynamicShowThumbnail');

var _onHoverDynamicShowThumbnail2 = _interopRequireDefault(_onHoverDynamicShowThumbnail);

var _xmlFileBackupSettings = require('./xmlFileBackupSettings');

var _xmlFileBackupSettings2 = _interopRequireDefault(_xmlFileBackupSettings);

var _selectionList = require('./selectionList');

var _selectionList2 = _interopRequireDefault(_selectionList);

var _adminOrderDetail = require('./Initializers/adminOrderDetail');

var _adminOrderDetail2 = _interopRequireDefault(_adminOrderDetail);

var _filterOrdersByCustomerId = require('./Initializers/filterOrdersByCustomerId');

var _filterOrdersByCustomerId2 = _interopRequireDefault(_filterOrdersByCustomerId);

var _alternativePp = require('./Initializers/alternativePp');

var _alternativePp2 = _interopRequireDefault(_alternativePp);

var _xmlFeedBackups = require('./Initializers/xmlFeedBackups');

var _xmlFeedBackups2 = _interopRequireDefault(_xmlFeedBackups);

var _commonSaver = require('./Initializers/commonSaver');

var _commonSaver2 = _interopRequireDefault(_commonSaver);

var _customerGroup = require('./Initializers/customerGroup');

var _customerGroup2 = _interopRequireDefault(_customerGroup);

var _termsConditions = require('./Initializers/termsConditions');

var _termsConditions2 = _interopRequireDefault(_termsConditions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [_dispatchAction2.default, _initializer2.default, _ajax2.default, _dataTable2.default, _select2.default, _tooltip2.default, _notify2.default, _confirm2.default, _trigger2.default, _moment2.default, _datepicker2.default, _tabs2.default, _productLists2.default, _switcher2.default, _showRelated2.default, _downloadIcons2.default, _gallery2.default, _lazyImage2.default, _clearModal2.default, _editCell2.default, _nestable2.default, _menuItemCopy2.default, _productPriority2.default, _watchdogAuthor2.default, _appliedDiscounts2.default, _userComplaints2.default, _dataCopy2.default, _newsletters2.default, _productPriceCheck2.default, _dropzone2.default, _clipboard2.default, _cmsPageSections2.default, _cmsPageSectionFiles2.default, _contestResponses2.default, _select2templates2.default, _closeModal2.default, _dropzoneMaxFilesize2.default, _fileManagerBreadcrumbs2.default, _updateImageId2.default, _dynamicLoadContent2.default, _fileManagerFolder2.default, _removeTooltipManual2.default, _onHoverDynamicShowThumbnail2.default, _xmlFileBackupSettings2.default, _selectionList2.default, _adminOrderDetail2.default, _filterOrdersByCustomerId2.default, _alternativePp2.default, _xmlFeedBackups2.default, _productWishList2.default, _commonSaver2.default, _customerGroup2.default, _termsConditions2.default];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers.js
// module id = 438
// module chunks = 0